// @generated by TypeGen from LogbookApp/DeviceDebugTraceApi.swift - DO NOT EDIT

import { IShipUserLevel } from "../LogbookModel/ShipUser"
import type { IAppResponse } from "./Routes"

export interface IDebugDatabaseUploadRequest {
  kind: IDebugDatabaseKind;
}

export interface IDebugDatabaseUploadResponse {
  success: boolean;
}

export interface IDebugNMEAUploadResponse {
  success: boolean;
  bytes: number;
}

export interface IDebugUploadResponse {
  success: boolean;
  uploaded: string[];
  failed: string[];
}

export enum IDebugDatabaseKind {
  ship = "ship",
  app = "app",
}

export interface DeviceDebugTraceApiAppEndpoints {
  "POST /api/debug/database": {
    params: {};
    query: {};
    request: IDebugDatabaseUploadRequest;
    response: IDebugDatabaseUploadResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/debug/log": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    permission: {};
  };
  "POST /api/debug/nmea": {
    params: {};
    query: {};
    request: never;
    response: IDebugNMEAUploadResponse;
    permission: { ship: IShipUserLevel };
  };
  "POST /api/debug/upload": {
    params: {};
    query: {};
    request: never;
    response: IDebugUploadResponse;
    permission: {};
  };
}

export const deviceDebugTraceApiAppEndpoints = {
  "POST /api/debug/database": { permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/debug/log": { permission: {} },
  "POST /api/debug/nmea": { permission: { ship: IShipUserLevel.primary } },
  "POST /api/debug/upload": { permission: {} },
} as const;
